import MobilePage from './MobilePage';
export default MobilePage;